import { pushToDataLayer } from '@/utils/analytics';
import { buildPageviewEvent, findLocationByName, PagePlatform } from '@rental/prebooking-ui-utils';
import usePageData, { useOldJwt } from '@/hooks/use-data/use-data';

const usePageviewTracking = () => {
  const { webView, cityName, language } = usePageData();
  const jwt = useOldJwt();

  const sendPageviewEvent = async () => {
    // Ensure required data is available
    if (!cityName) {
      console.warn('Cannot send pageview event: missing city name');
      return;
    }

    const location = findLocationByName(cityName);
    if (!location) {
      console.warn(`Cannot send pageview event: location not found for city ${cityName}`);
      return;
    }

    // Include current path in the event data
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';

    // Log when events are sent in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`Sending pageview event for ${currentPath}`, {
        webView,
        cityName,
        platform: webView ? 'app' : 'web'
      });
    }

    // @ts-ignore
    pushToDataLayer(buildPageviewEvent({
      country: findLocationByName(cityName).country,
      language: language,
      cityName: cityName,
      pagePlatform: webView ? PagePlatform.app : PagePlatform.web,
      jwt,
      // Add path to improve tracking
      path: currentPath,
    }));
  };

  return { sendPageviewEvent };
};

export default usePageviewTracking;
